import React, { Component } from 'react'
import { navigate } from 'gatsby'
import Link from '../utils/link'
import Select from 'react-select'
import Dropzone from 'react-dropzone'

const encode = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k)=>{
    formData.append(k, data[k])
  });
  return formData
}

const sponsorshipType = [
  { label: 'Monetary contribution', value: 'Monetary contribution' },
  { label: 'Goods donated', value: 'Goods donated' },
  { label: 'Services provided', value: 'Services provided' },
  { label: 'Time volunteered', value: 'Time volunteered' },
]

const ongoing = [
  { label: 'On-going Support', value: 'On-going support' },
  { label: 'One off event', value: 'One off event' },
]

class CommunityForm extends Component {

  state = {
    result: null,
    msg: null,
    documents: [],
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onDrop = (documents) => {
    this.setState({
      documents: documents,
      'further_documents': documents[0]
    })
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option.value
        this.setState(state)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state)
        break
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    fetch("/", {
      method: "POST",
      body: encode({
        "form-name": this.form.current.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch(error => this.setState({ result: "fail", msg: error }))
      .finally(() => {
        // Re-enable the submit button after the request completes
        this.setState({ isSubmitting: false })
      });
  }

  render() {

    let { documents } = this.state

    let props = {
      ref: this.form,
      name: 'community',
      className: 'form form--community',
      'data-netlify': 'true',
      'data-netlify-honeypot': 'bot-field',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success")
      return (
        <p className="contact__success">
          Thanks for nominating a cause.
          <br /> A member of our team will be in touch soon.
        </p>
      )

    return (

      <form {...props}>

        <div className='column_left'>

          { this.state.msg && <div className='error'>{ this.state.msg }</div> }

          <div className='form__row'>
            <label htmlFor='first-name-field'>Organisation name</label>
            <input type='text' name='organisation_name' id='organisation-name-field' className='form__input' onChange={this.handleChange} required />
          </div>

          <div className='form__row'>
            <label htmlFor='primary-contact-field'>Primary contact</label>
            <input type='text' name='primary_contact' id='primary-contact-field' className='form__input' onChange={this.handleChange} required />
          </div>

          <div className='form__row'>
            <label htmlFor='position-within-field'>Position within the organisation</label>
            <input type='text' name='position_within' id='position-within-field' className='form__input' onChange={this.handleChange} />
          </div>

          <div className='form__row'>
            <label htmlFor='contact-field'>Contact number</label>
            <input type='text' name='mobile' id='contact-field' className='form__input' onChange={this.handleChange} required  />
          </div>

          <div className='form__row'>
            <label htmlFor='email-field'>Email</label>
            <input type='email' name='email' id='email-field' className='form__input' onChange={this.handleChange} required  />
          </div>

          <div className='form__row'>
            <label htmlFor='link-to-website-field'>Link to website</label>
            <input type='text' name='website' id='link-to-website-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row'>

            <label htmlFor='sponsorship-type-field'>What type of sponsorship are you seeking?</label>

            <div className='form__select form__select--blue'>
              <Select
                options={sponsorshipType}
                onChange={this.handleSelectChange}
                openMenuOnFocus={true}
                id="sponsorship-type-field"
                name="sponsorship_type"
                placeholder="Please Select"
                className="react-select-container"
                classNamePrefix="react-select"
                ref={node => this.sponsorship_type = node}
              />
            </div>

          </div>

          <div className='form__row'>
            <label htmlFor='sponsorship-type-info-field'>Sponsorship type - expand on your selection above</label>
            <input type='text' name='sponsorship_type_info' id='sponsorship-type-info-field' className='form__input' onChange={this.handleChange} />
          </div>

          <div className='form__row'>

            <label htmlFor='sponsorship-type-field'>Do you require on-going support or is this for a specific event</label>

            <div className='form__select form__select--blue'>
              <Select
                options={ongoing}
                onChange={this.handleSelectChange}
                openMenuOnFocus={true}
                id="ongoing-field"
                name="ongoing"
                placeholder="Please Select"
                className="react-select-container"
                classNamePrefix="react-select"
                ref={node => this.ongoing = node}
              />
            </div>

          </div>

          <div className='form__row'>
            <label htmlFor='start-date-field'>Please specify date when sponsorship is required</label>
            <input type='date' name='start_date' id='start-date-field' className='form__input' onChange={this.handleChange} />
          </div>

          <div className='form__row'>
            <textarea name='small_brief' placeholder='Small brief of organisation and why you are seeking sponsorship' className='form__input form__textarea' onChange={this.handleChange} />
          </div>

          <div className='form__row'>
            <textarea name='how_do_you_align' placeholder='How do you think your organisation and Kollosche align?' className='form__input form__textarea' onChange={this.handleChange} />
          </div>

        </div>

        <div className='column_right'>

          <div className='form__row'>
            <label htmlFor='how-who-distributed-field'>How and who will the funds/goods be distributed to?</label>
            <input type='text' name='how_who_distributed' id='how-who-distributed-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row'>
            <label htmlFor='already-sponsored-field'>Is your organisation currently sponsored by anyone else?</label>
            <input type='text' name='already_sponsored' id='sponsorship-type-info-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row'>
            <label htmlFor='approved-field'>Is your organisation approved and registered with Australian Charities and Non-for profits Commission (ACNC)</label>
            <input type='text' name='approved_registered_acnc' id='approved-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row'>
            <label htmlFor='acnc-field'>Provide ACNC registration number</label>
            <input type='text' name='acnc_number' id='acnc-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row form__row--check'>
            <div className='form__checkbox'>
              <input type='checkbox' name='deductible' id='deductible-field' className='form__input' onChange={this.handleChange} />
              <label htmlFor='deductible-field'>Are you a deductible gift recipient registered with ACNC</label>
            </div>
          </div>

          <div className='form__row'>
            <label htmlFor='closing-dates-field'>Provide specific payment dates/closing dates</label>
            <input type='date' name='closing_dates' id='closing-dates-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row'>
            <label htmlFor='proposed-promotion-field'>What is your proposed promotion of Kollosche through your organisation? E.g print media, digital media, social media</label>
            <input type='text' name='proposed-promotion' id='proposed-promotion-field' className='form__input' onChange={this.handleChange}  />
          </div>

          <div className='form__row form__row--check'>
            <div className='form__checkbox'>
              <input type='checkbox' name='agree_advertise' id='agree-advertise-field' className='form__input' onChange={this.handleChange} />
              <label htmlFor='agree-advertise-field'>Agree to have Kollosche advertise and promote your organisation</label>
            </div>
          </div>

          <div className='form__row form__row--check'>
            <div className='form__checkbox'>
              <input type='checkbox' name='agree_socials' id='agree-socials-field' className='form__input' onChange={this.handleChange} />
              <label htmlFor='agree-socials-field'>Agree to link your website and social sites to Kollosche</label>
            </div>
          </div>

          <div className='form__row form__row--check'>
            <div className='form__checkbox'>
              <input type='checkbox' name='agree_testimonials' id='agree-testimonials-field' className='form__input' onChange={this.handleChange} />
              <label htmlFor='agree-testimonials-field'>Agree to provide testimonial if sponsorship is granted</label>
            </div>
          </div>

          <div className='form__row form__file'>
            <label htmlFor='further-documents-field'>If you have any further documentation or proposals, required for your submission, please upload here.</label>
            <Dropzone onDrop={this.onDrop} multiple={false}>
              {({getRootProps, getInputProps}) => (
                <div  {...getRootProps({className: 'dropzone form__dropzone'})}>
                  <input name='further_documents' {...getInputProps()} />
                  <p>Drag and drop<br />
                  Or browse to choose a file</p>
                  { documents.length === 0 && <span>.png, .jpg, .pdf accepted, up to 6MB</span> }
                  { documents.length > 0 && documents.map((file, i) =>
                    <div key={i}>{file.name} - {file.size} bytes</div>
                  )}
                </div>
              )}
            </Dropzone>
          </div>

          <div className='form__row form__row--check'>
            <div className='form__checkbox'>
              <input type='checkbox' name='agree_terms' id='agree-terms-field' className='form__input' onChange={this.handleChange} />
              <label htmlFor='agree-terms-field'>I agree to the terms of <strong><Link to='/privacy-policy/'>Kollosche's Privacy Policy</Link></strong></label>
            </div>
          </div>

          <div className='form__row form__row--submit'>

            <button type='submit' className='btn btn--border' disabled={this.state.isSubmitting}>Apply Now</button>

          </div>

        </div>

      </form>
    )
  }
}

export default CommunityForm
